import { Card, Centralizer } from '@/components';
import type { FC, PropsWithChildren } from 'react';

type Props = {
  width?: number;
};

export const FormCentralizer: FC<PropsWithChildren<Props>> = ({
  children,
  width = 480,
}) => {
  return (
    <Centralizer>
      <Card style={{ width }}>{children}</Card>
    </Centralizer>
  );
};
